module.exports = __webpack_public_path__ + "media/videos/term-bg-3-dd752efc.jpg";